module.exports = __webpack_public_path__ + "img/face-masks.c0d78fa9.jpeg";